import theme from "theme";

const { default: styled } = require("@emotion/styled");

const CardContainerStyle = styled.div`
  padding: 0px 16px 16px 16px;
`;

const HeaderStyle = styled.div`
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333333;
`;

const RowContainerStyle = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: flex-start;
`;

const RowStyle = styled.div`
  flex: 1 1 40%;
  font-size: 14px;
  color: #555555;
  padding: 4px;
  display: flex;
  align-items: center;
`;

const LabelContainerStyle = styled.span`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  font-weight: 500;
  color: black;
  font-size: 13px;
`;

const ValueContainerStyle = styled.span`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  color: #666666;
  font-size: 13px;
`;

const LeasingLayout = styled.div`
  //margin-top: 50px;
  border-bottom: 1px solid ${theme.colors.bordertask};
`;

const BodyHeader = styled.div`
  padding: 12px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const FilterContainer = styled.div`
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 16px 24px;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;

const DrawerTitlesContainer = styled.div`
  display: flex;
  background: ${theme.gradient.themeGradient};
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 20px;
  height: 50px;
  position: sticky;
  top: 0;
  z-index: 1000;
  margin-bottom: 10px;
`;

const CloseIcon = styled.p`
  cursor: pointer;
  color: white;
`;

const DrawerTitles = styled.span`
  font-size: 17px;
  color: white;
  font-weight: normal;
`;

const SC = {
  CardContainerStyle,
  HeaderStyle,
  RowContainerStyle,
  RowStyle,
  LabelContainerStyle,
  ValueContainerStyle,
  LeasingLayout,
  BodyHeader,
  FilterContainer,
  DrawerTitlesContainer,
  CloseIcon,
  DrawerTitles,
};

export default SC;
